import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchUsers, deleteUser } from "actions/user";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class UserIndex extends Component {
  componentDidMount() {
    this.props.fetchUsers();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchUsers({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { userURL: user_url } = this.props.match.params;
    this.props.fetchUsers({ user_url, page, ...this.search });
  };

  handleUserDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteUserProcess(id);
      },
      title: "Delete user",
      body: "Are you sure you want to delete this user?"
    });
  };

  deleteUserProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteUser, match } = this.props;
    const { userURL: user_url } = match.params;
    deleteUser(id, { user_url })
      .then(() => {
        this.props.fetchUsers({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete User Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { users } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table users={users} onClickDelete={this.handleUserDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={users.current_page}
            lastPage={users.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, users, confirmationPopupActive }) => ({
  authUser,
  users,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchUsers, deleteUser, toggleconfirmationPopup, toggleNotification }
)(UserIndex);



// WEBPACK FOOTER //
// ./src/pages/User/Index/index.js